import { useLocation } from '@gatsbyjs/reach-router'

const extractFirstPathComponent = (path: string) => {
  const firstPathSep = path.indexOf('/')
  if (firstPathSep === -1) {
    return path
  }
  if (firstPathSep > 0) {
    return path.substring(0, firstPathSep)
  }
  const nextPathSep = path.indexOf('/', 1)
  return nextPathSep === -1 ? path.substring(1) : path.substring(1, nextPathSep)
}

export function useDispensarySlug(): string | undefined {
  const location = useLocation()
  const pathStartsWithDispensary = location.pathname.startsWith('/u/')
  return pathStartsWithDispensary
    ? extractFirstPathComponent(location.pathname.substring(3))
    : undefined
}
